"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var styles_1 = require("./styles");
var helpers_1 = require("../helpers");
var types_1 = require("./types");
var ALIGNS_VALUES = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    fill: 'stretch'
};
var DISTRIBUTION_VALUES = {
    fill: '',
    between: 'space-between;',
    center: 'center'
};
var Wrapper = styled_components_1.default(react_1.default.forwardRef(function (_a, ref) {
    var asTag = _a.asTag, children = _a.children, rest = __rest(_a, ["asTag", "children"]);
    return react_1.default.createElement(asTag || 'div', helpers_1.clearProps(rest, { ref: ref }), children);
}))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    display: inline-flex;\n    flex-direction: row;\n    align-items: ", ";\n    justify-content: ", ";\n\n    ", "}\n    ", "}\n    ", ";\n    ", "\n    ", "\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    ", ";\n    display: inline-flex;\n    flex-direction: row;\n    align-items: ", ";\n    justify-content: ",
    ";\n\n    ", "}\n    ", "}\n    ",
    ";\n    ",
    "\n    ",
    "\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), styles_1.base, function (_a) {
    var align = _a.align;
    return (align ? ALIGNS_VALUES[align] : 'flex-start');
}, function (_a) {
    var distribution = _a.distribution;
    return distribution ? DISTRIBUTION_VALUES[distribution] : 'flex-start';
}, function (_a) {
    var size = _a.size;
    return ((size === null || size === void 0 ? void 0 : size.width) ? "width: " + size.width : '');
}, function (_a) {
    var size = _a.size;
    return ((size === null || size === void 0 ? void 0 : size.height) ? "height: " + size.height : '');
}, function (_a) {
    var distribution = _a.distribution;
    return distribution === types_1.VIEW_DISTRIBUTION.fill && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            & > * {\n                flex: 1 1 auto;\n            }\n        "], ["\n            & > * {\n                flex: 1 1 auto;\n            }\n        "])));
}, function (_a) {
    var contentMod = _a.contentMod;
    return contentMod === types_1.VIEW_CONTENT_MOD.fill && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            align-items: stretch;\n            & > * {\n                flex: 1 1 auto;\n                max-width: 100%;\n            }\n        "], ["\n            align-items: stretch;\n            & > * {\n                flex: 1 1 auto;\n                max-width: 100%;\n            }\n        "])));
}, function (_a) {
    var contentMod = _a.contentMod;
    return contentMod === types_1.VIEW_CONTENT_MOD.center && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            align-items: center;\n            justify-content: center;\n        "], ["\n            align-items: center;\n            justify-content: center;\n        "])));
}, styles_1.background, styles_1.spacing, styles_1.borders, styles_1.clipped, styles_1.scroll, styles_1.root, styles_1.spaceFill, styles_1.size, styles_1.collapsable);
exports.View = helpers_1.createUIElement('View', function (_a, ref) {
    var className = _a.className, _b = _a.asTag, asTag = _b === void 0 ? 'div' : _b, _c = _a.collapsable, collapsable = _c === void 0 ? true : _c, testId = _a.testId, onFocus = _a.onFocus, onBlur = _a.onBlur, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragEnter = _a.onDragEnter, onDragExit = _a.onDragExit, onDragLeave = _a.onDragLeave, onDragOver = _a.onDragOver, onDragStart = _a.onDragStart, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "asTag", "collapsable", "testId", "onFocus", "onBlur", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || testId, className: "vm-View " + className, asTag: asTag, collapsable: collapsable, onFocus: onFocus, onBlur: onBlur, onDrag: onDrag, onDragEnd: onDragEnd, onDragEnter: onDragEnter, onDragExit: onDragExit, onDragLeave: onDragLeave, onDragOver: onDragOver, onDragStart: onDragStart, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=View.js.map